
import moment from 'moment';
import 'moment-timezone'; // Saat dilimleri için gerekli


const getGivenDateAndTime = (dateString) => {

    moment.locale('tr');
    moment.tz.setDefault('Europe/Istanbul');

    const dateTime = moment.tz(dateString, 'Europe/Istanbul');

    const formattedDate = dateTime.format('LL'); // Tarih
    const formattedTime = dateTime.format('LT'); // Saat

    return {
        formattedDate,
        formattedTime
    }

}

export default getGivenDateAndTime